import React from 'react'

export default () => (
  <div>
    <div className="head">
      <div className="container">
        <img
          src="https://s3-eu-west-1.amazonaws.com/web-designio/website-dan/img/dan-logo.png"
          alt="DAN EV - Dienst am Nächsten"
          className="logo"
        />
        <span
          id="global-slogan"
          data-editable="simpletext"
          className="slogan"
          data-global="data-global"
        >
          Nachbarschaftshilfe
          <br />
          von Mensch zu Mensch
        </span>
        <div className="hotline">
          <strong
            id="global-fragen"
            data-editable="simpletext"
            data-global="data-global"
          >
            Sie haben Fragen?
          </strong>
          <br />
          <span
            id="global-phone"
            data-editable="simpletext"
            data-global="data-global"
          >
            0174/3444893
            <br />
          </span>
        </div>
      </div>
    </div>
    <div className="nav">
      <div className="container">
        <ul className="clearfix">
          <li>
            <a href="/home">Startseite</a>
          </li>
          <li>
            <a href="/geschichte">Geschichte</a>
          </li>
          <li>
            <a href="/dienstleistungen">Dienstleistungen</a>
          </li>
          <li>
            <a href="/sie-wollen-helfen">Sie wollen helfen?</a>
          </li>
          <li>
            <a href="/mitglieder">Mitglieder</a>
          </li>
          <li>
            <a href="/kontakt">Kontakt</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="content">
      <div className="container">
        <h1 id="impressum" data-editable="simpletext">
          Impressum
        </h1>
        <p id="adresse" data-editable="simpletext">
          <strong>
            Dienst am Nächsten e.V.&nbsp;
            <br /> Clarissenstr. 11 &nbsp;
            <br /> 89077 Ulm&nbsp;
          </strong>
        </p>
        <br />
        <div id="table" data-editable="text">
          <table cellPadding={1} cellSpacing={0} style={{ width: '30%' }}>
            <tbody>
              <tr>
                <td>Email:</td>
                <td>
                  <a href="mailto:info@dan-ev.de">info@dan-ev.de</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <p id="content" data-editable="text">
          1. Vorsitzender: Gerhard Fischer; Geschäftsführung: Andreas
          Baier&nbsp;
          <br />
          <br /> Haftungshinweis:&nbsp;
          <br />
          <br /> Alle Inhalte dieser Internet Seiten, werden mit sorgfältiger
          inhaltlicher Kontrolle recherchiert. Gleichwohl übernimmt der Dienst
          am Nächsten e.V. keine Haftung für die Richtigkeit, Vollständigkeit
          und Aktualität der bereitgestellten Informationen. Alle Inhalte
          externer Links unterliegen der Haftung der jeweiligen Anbieter. Für
          die Inhalte externer Links übernehmen wir keine Haftung. Für die
          Inhalte der verlinkten Seiten sind ausschließlich deren Betreiber
          verantwortlich.
        </p>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/impressum.js